
// Renders the game board with locked blocks
import { GAME_CONFIG } from '../gameConfig';

// Draw the game board with all locked blocks
export function drawBoard(scene, board) {
  // Clear previous board graphics
  if (scene.boardGraphics) {
    scene.boardGraphics.forEach(graphic => graphic.destroy());
  }
  scene.boardGraphics = [];
  
  // Draw each cell on the board
  for (let y = 0; y < GAME_CONFIG.boardHeight; y++) {
    for (let x = 0; x < GAME_CONFIG.boardWidth; x++) {
      const cell = board[y][x];
      
      // Only draw filled cells
      if (cell !== 0) {
        // Calculate cell position
        const cellX = x * GAME_CONFIG.blockSize;
        const cellY = y * GAME_CONFIG.blockSize;
        
        // Create the cell graphics
        const cellGraphic = scene.add.rectangle(
          cellX, cellY,
          GAME_CONFIG.blockSize, GAME_CONFIG.blockSize,
          cell
        ).setOrigin(0);
        
        // Add border to the cell
        const border = scene.add.rectangle(
          cellX, cellY,
          GAME_CONFIG.blockSize, GAME_CONFIG.blockSize,
          0xffffff, 0
        ).setOrigin(0);
        border.setStrokeStyle(2, 0x000000, 0.3);
        
        // Save reference to the graphics
        scene.boardGraphics.push(cellGraphic);
        scene.boardGraphics.push(border);
      }
    }
  }
}
